
const m = window.require("mewe/helpers/__");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
